<template>
  <el-dialog
    class="dialogSearchGroupByLink"
    width="800px"
    :close-on-click-modal="false"
    :visible="true"
    @close="$emit('close')">
    <div
      slot="title"
      class="d-flex align-items-center justify-content-between pb-2 px-3 py-2 border-bottom"
      style="margin-top: -10px">
      <div class="d-flex align-items-center mt-2">
        <span
          class="font-16 fw-700"
          style="width: 130px">
          Tham gia nhóm
        </span>
        <el-input
          v-model="link"
          ref="inputMesage"
          style="width: 240px"
          size="small"
          clearable
          placeholder="Nhập link nhóm"
          @keydown.enter.exact.native="searchGroupByLink"></el-input>
      </div>
      <el-select
        class="me-4 mt-2"
        @change="changeAccount"
        v-model="selectAccountId"
        filterable
        default-first-option
        placeholder="Chọn tài khoản"
        size="small"
        style="max-width: 160px">
        <el-option
          v-for="account in accounts"
          :key="account.accountId"
          :label="getAccountName(account)"
          :value="account.accountId"></el-option>
      </el-select>
    </div>
    <div class="d-flex px-3 align-items-center justify-content-between py-4">
      <div
        v-if="groupInfo.groupId"
        class="d-flex flex-column">
        <span class="fw-700 font-16 mb-2">{{ groupInfo?.name }}</span>
        <span class="fw-400 font-14 mb-3">{{ groupInfo?.desc || "Nhóm chưa có mô tả" }}</span>
        <el-button
          type="primary"
          @click="clickJoinGroup">
          Tham gia nhóm
        </el-button>
      </div>
      <div
        v-else
        class="d-flex w-100 justify-content-center align-items-center"
        style="height: 80px">
        Nhập thông tin nhóm
      </div>
      <div
      v-if="groupInfo.groupId"
        class="px-1 pt-1 m-1"
        style="border: thin solid #73afff; border-radius: 5px">
        <qrcode-vue
          :size="105"
          :value="link"
          level="H" />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { HTTP } from "@/lib/http-common";
import QrcodeVue from "qrcode.vue";

export default {
  // props: ["visidle"],
  components: { QrcodeVue },
  data() {
    return {
      link: "",
      selectAccountId: "",
      accounts: [],
      groupInfo: {},
    };
  },
  methods: {
    changeAccount() {
      this.searchGroupByLink();
    },
    getAccounts() {
      HTTP.get("/api/account").then((resp) => {
        if (resp.status === "success") {
          this.accounts = resp.data;
          this.selectAccountId = this.accounts[0].accountId;
        }
      });
    },
    searchGroupByLink() {
      if(!this.selectAccountId || !this.link) return
      this.$http
        .get(`/api/message/getGroupInfoByLink?accountId=${this.selectAccountId}&link=${this.link}`)
        .then((resp) => {
          this.groupInfo = resp.data.data;
        })
        .catch(() => {
          this.groupInfo = {};
        });
    },
    clickJoinGroup() {
      this.$http
        .get(`/api/message/joinGroupFromLink?accountId=${this.selectAccountId}&link=${this.link}`)
        .then((resp) => {
          this.alert("success", resp.data.error_message);
          this.$emit("close");
        })
        .catch(() => {
          this.groupInfo = {};
        });
    },
  },
  created() {
    this.getAccounts();
  },
};
</script>

<style lang="scss" >
.dialogSearchGroupByLink {
  .el-dialog__body {
    padding: 0 !important;
  }
  .el-dialog__header {
    padding: 0 !important;
  }
}
</style>